/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

// Fetches media powder list for inventory
const getMediaPowderList = async (page: number, size: number, sort: any, order: any, keyword: any, status?: string, lot?: string, mediaType?: string, fromDate?: string, toDate?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/list?page=${page}&size=${size}&sort=${sort}&order=${order}${keyword ? `&keyword=${keyword}` : ''}${status ? `&status=${status}` : ''}${lot ? `&batch_name=${lot}` : ''}${mediaType ? `&media_name=${mediaType}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media powder statistics for dashboard cards
const getMediaPowderStats = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/statistics`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

  // Fetches batch codes for the filter dropdown
const getBatchCodes = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/list?page=1&size=1000&sort=id&order=desc`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches media powder lot details (Batch Details screen)
const getMediaPowderLotDetails = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media_powder/list_powder_batch_lot_details?page=1&size=50&sort=id&order=asc&batch_id=${batchId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches lot usage & transaction details (Batch Lot Distribution screen)
const getMediaPowderLotUsageDetails = async (
    lotId: string,
    page: number,
    size: number,
    keyword?: string,
    fromDate?: string,
    toDate?: string
  ) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/media_powder/view_lot?lot_id=${lotId}&page=${page}&size=${size}&sort=id&order=desc${keyword ? `&keyword=${keyword}` : ''}${fromDate ? `&from_date=${fromDate}` : ''}${toDate ? `&to_date=${toDate}` : ''}`,
        {
          headers: {
            "x-auth-token": authToken,
            "x-userid": authUserID,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data;
      }
    }
  };


// Fetches media product definitions 
const getMediaProductDefinitions = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_product_definitions?sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Creates a new media powder lot
const createMediaPowder = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media_powder/save`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

export const MediaPowderService = {
  getMediaPowderList,
  getMediaPowderStats,
  getBatchCodes,
  getMediaPowderLotDetails,
  getMediaPowderLotUsageDetails,
  getMediaProductDefinitions,
  createMediaPowder,
};